import $ from 'jquery';

export function renderSearchTimelineSlider() {
	if (!window.RBS_SD || !window.RBS_SD.config) {
		console.error('no config loaded');
	}

	const slider = $('.searchTimelineSlider');
	const fromInput = $('#searchTimeFrom');
	const toInput = $('#searchTimeTo');

	const fromYear = parseInt(fromInput.val(), 10);
	const toYear = parseInt(toInput.val(), 10);

	const sliderConfig = {
		range: true,
		min: window.RBS_SD.config.minYear,
		max: window.RBS_SD.config.maxYear,
		values: [fromYear, toYear],
	};

	function onSlide(e, ui) {
		fromInput.val(ui.values[0]);
		toInput.val(ui.values[1]);

		$(ui.handle).html('<span>' + ui.value + '</span>');
	}

	function onSlideCreate(e, ui) {
		const handles = $(this).find('.ui-slider-handle');
		handles.eq(0).html('<span>' + fromYear + '</span>');
		handles.eq(1).html('<span>' + toYear + '</span>');
	}

	slider
		.on({slide: onSlide, slidecreate: onSlideCreate})
		.slider(sliderConfig);
}
